export enum DisplayKind {
  standard,
  gallerie,
  list,
  edit,
  showMedia,
}

export type MaterialKind = {
  value: string,
  title: string,
  displayKind?: DisplayKind
}

export const Materialkinds = [
  {
    value: 'expandable',
    title: 'Verbrauchsmaterialien',
    displayKind: DisplayKind.standard
  },
  {
    value: 'inventory',
    title: 'Bestand',
    displayKind: DisplayKind.standard
  },
  {
    value: 'digitalFlip',
    title: 'Flips',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'digitalHandout',
    title: 'Handout A4',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'digitalHandoutA5',
    title: 'Handout A5',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'digitalPoster',
    title: 'Plakate',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'digitalPin',
    title: 'Pins',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'digitalFile',
    title: 'Dateien',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'collectible',
    title: 'Lernkarten',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'moderationCard',
    title: 'Moderationskarten',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'moderationCardLong',
    title: 'Mod lang',
    displayKind: DisplayKind.gallerie
  },
  {
    value: 'collection',
    title: 'Kollektionen',
    displayKind: DisplayKind.standard
  },
  {
    value: 'specialFormat',
    title: 'Sonderformate',
    displayKind: DisplayKind.standard
  },
  {
    value: 'vehicles',
    title: 'Fahrzeuge',
    displayKind: DisplayKind.standard
  },
];
